<template>
  <v-row justify="end" class="mt-0 pt-0 pa-5 ga-2" no-gutters>
    <slot/>
  </v-row>
</template>

<script lang="ts">
import {Component, Vue, toNative} from 'vue-facing-decorator'

/**
 * A linha de ações do rodapé de um modal: os botões à direita, com o espaço entre eles.
 *
 * Existe porque este arranjo — `justify="end"`, as margens zeradas em cima e o `pa-5` em volta —
 * estava escrito letra por letra no painel de formulário (o Salvar) e no diálogo de pergunta (as
 * saídas dela), e o Salvar da troca rápida de valor seria a terceira cópia. São quatro classes
 * mágicas que ninguém reconfere ao mexer numa delas: foi assim que o espaçamento dos botões já
 * divergiu de um diálogo para o outro uma vez.
 *
 * **O espaço entre os botões é `ga-2` no contêiner**, e não um `pl-2` a partir do segundo filho.
 * O resultado é o mesmo e a regra deixa de depender da POSIÇÃO de cada um — quem usa só põe os
 * botões no slot, sem embrulhar cada um num `v-col` nem contar índice.
 *
 * Só a linha, de propósito: que botões são, o que dizem e quando ficam desabilitados é de quem
 * usa. Um botão aqui dentro viraria um parâmetro por diferença entre os três.
 */
@Component({name: 'ontos-dialog-action-row'})
class DialogActionRow extends Vue {
}

export default toNative(DialogActionRow)
</script>
